import { Component, OnInit, AfterViewInit } from '@angular/core';
import { KeyValue } from '@angular/common';
import { ApiService } from '../../services/api/api.service';

declare const WOW: any;

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styles: []
})

export class DashboardComponent implements OnInit, AfterViewInit {

  ngAfterViewInit(): void {
    new WOW().init();
  }

  stats: any = null;

  constructor(private api: ApiService) { }

  ngOnInit() {
    this.api.getStats().subscribe(response => {
      this.stats = response;
      console.log(response);
    }, error => {
      console.error(error);
    });
  }

  valueDescOrder(a: KeyValue<number,string>, b: KeyValue<number,string>): number {
    return a.value > b.value ? -1 : (b.value > a.value ? 1 : 0);
  }
}
